import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';




import './../Comp/Home.css'

import { useNavigate } from 'react-router-dom';

export const Home = () => {
    const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate =useNavigate();
  useEffect(() => {

    const token = localStorage.getItem('token')

    if (!token) {
      navigate("/login"); // Redirect to login page if no token found
    }
    console.log(token)
    const fetchUsers = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);


      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: new FormData(),
        redirect: "follow",
      };

      try {
        const response = await fetch(
          "https://backend.booknxtcoin.com/api/admin/users",
          requestOptions
        );
        const result = await response.json();
        if (result.code === 200 && result.status === "success") {
          setUsers(result.data.data);
        } else {
          setError("Failed to fetch users");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  return (
    <>

    
    

    <div className="container mt-4">
      <h2 className="mb-3">User List</h2>
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Registered IP</th>
            <th>A Wallet</th>
            <th>B Wallet</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.email}</td>
              <td>{user.registered_ip || "N/A"}</td>
              <td>{user.a_wallet}</td>
              <td>{user.b_wallet}</td>
              <td>{new Date(user.created_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>



    </>
  )
}
